import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import bs from '../locales/bs.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      bs: { translation: bs },
    },
    lng: 'bs',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;